<script setup>
import ArticleAnnounce from "@/components/ArticleAnnounce";
import { articles } from "@/data/articles";
</script>

<template>
  <div class="kakao-academy">
    <div class="kakao-academy__top">
      <h1 class="kakao-academy__title">Какао-академия</h1>
      <p class="kakao-academy__descr">Узнайте много интересных фактов о&nbsp;какао и&nbsp;шоколаде Nestle.</p>
      <div class="kakao-academy__bob">
        <!-- <p>Я - какао-Боб!<br/> Давай вместе со мной<br/> узнаем...</p> -->
        <p>Я&nbsp;&mdash; какао-Боб!<br/>Давай вместе<br/>со&nbsp;мной узнаем...</p>
      </div>
    </div>
    <article-announce v-for="(block, index) in articles" :key="block.title" :data="block" :color="block.bg" :id="index"/>
    <div class="kakao-academy__info">
      <div class="kakao-academy__info-title">
        <h3>Зачем<br/> Какао-<br/>академия?</h3>
        <p>Просто и&nbsp;понятно о&nbsp;какао <br/>и&nbsp;шоколаде Nestlé</p>
      </div>
      <ul>
        <li>Поймёшь, как делают шоколад</li>
        <li>Узнаешь, из чего состоит шоколад</li>
        <li>Разберёшься в видах шоколада</li>
      </ul>
      <div class="kakao-academy__info-decor">
        Давайте любить <br/>шоколад вместе!
      </div>
    </div>
  </div>
</template>
